import {
  dbUserSavedProduct,
  dbAcceptEmails,
  dbUser,
  dbViewedProducts,
  dbViewedProduct,
} from "./dbreferences"
import firebaseObjectToArray from "../reuseableFunctions/firebaseObjectToArray"
import firebase from "gatsby-plugin-firebase"

export const removeSavedproduct = (uid, firebaseKey) => {
  dbUserSavedProduct(uid, firebaseKey).remove()
}

export const setEmailPreference = (uid, preference) => {
  dbAcceptEmails(uid).set(preference)
}

export const deleteUser = uid => {
  dbUser(uid).remove()
}

export const registerRecentView = (uid, productId, image) => {
  dbViewedProducts(uid).once("value", snapshot => {
    const recentlyViewedObject = {
      productId: productId,
      dateViewed: firebase.database.ServerValue.TIMESTAMP,
      image: image,
    }

    if (!snapshot.val()) {
      // if recently viewed node as a whole non existant create the node and push new product as a child of that node
      dbViewedProducts(uid).push(recentlyViewedObject)
    } else {
      // loops to find if there are any duplicates and filters any.
      // should ONLY RETURN ONE ITEM IN THE ARRAY
      const productsFirebaseKey = firebaseObjectToArray(snapshot.val()).filter(
        element => element.productId === productId
      )
      // if the filter returns anything in the array do the first if not carry out second.
      productsFirebaseKey.length > 0
        ? // the shorten import version ref with update function always returns undefined possible firebase bug
          firebase
            .database()
            .ref(
              `users/${uid}/viewedProducts/${productsFirebaseKey[0].firebaseKey}`
            )
            .update(recentlyViewedObject)
        : // creates a new viewed product
          dbViewedProducts(uid).push(recentlyViewedObject)
    }
  })
}
